import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// import { ButtonsModule } from '@shared/core/components/buttons';
import { HeadersModule } from '@shared/core/components/headers';
import { TwoColumnsModule } from '@shared/core/components/twoColumns';
import { LinkModule } from '@shared/core/components/link';
import { FormForAdyenCVVModule } from '@shared/core/modules/forms/formTypes/forAdyenCVV';

import { ModalsTypesModule } from '../../modalsTypes';

import { ModalForAdyenCVVComponent } from './modal-for-adyen-cvv.shared.component';

@NgModule({
    declarations: [
        ModalForAdyenCVVComponent
    ],
    imports: [
        CommonModule,
        ModalsTypesModule,
        FormForAdyenCVVModule,
        HeadersModule,
    ],
    exports: [
        ModalForAdyenCVVComponent
    ],
})
export class ModalForAdyenCVVModule {}
